import React from "react";
import { Link } from "react-router-dom";

const PopupModal = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 z-50">
            <div className="bg-white rounded-lg p-6 max-w-lg w-full max-h-full relative overflow-auto">
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 text-gray-500 hover:text-gray-700"
                    aria-label="Close"
                >
                    ✕
                </button>
                <h2 className="text-2xl font-bold mb-4">Important Information</h2>
                <p className="mb-4">Coreply isn't on Play Store. You might deal with these Android restrictions:</p>
                <div className="space-y-4">
                    <details className="border rounded-md p-4">
                        <summary className="font-medium">1. Unknown apps not allowed</summary>
                        <p className="mt-2">
                            Allow the "Install unknown apps" option in settings when prompted by the system.
                        </p>
                    </details>
                    <details className="border rounded-md p-4">
                        <summary className="font-medium">2. Play Protect blocking installation</summary>
                        <p className="mt-2">
                            Play Protect may block sideloaded apps. Learn how to&nbsp;
                            <a
                                href="https://support.google.com/android/answer/2812853?hl=en"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 underline"
                            >
                                turn off Play Protect
                            </a>
                            . If you use a Samsung device, you may also need to&nbsp;
                            <a
                                href="https://www.samsung.com/latin_en/support/mobile-devices/protect-your-galaxy-device-with-the-new-auto-blocker-feature/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 underline"
                            >
                                turn off Autoblocker
                            </a>
                        </p>
                    </details>
                    <details className="border rounded-md p-4">
                        <summary className="font-medium">3. Restricted accessibility settings</summary>
                        <p className="mt-2">
                            Coreply requires accessibility permissions. But your device may restrict some settings for
                            sideloaded apps. Learn how to&nbsp;
                            <a
                                href="https://support.google.com/android/answer/12623953?hl=en&sjid=4519247821910480682-NC"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 underline"
                            >
                                allow restricted settings
                            </a>
                            .
                        </p>
                    </details>
                    <Link
                        to="https://github.com/coreply/coreply/releases/latest"
                        className="mt-6 px-6 py-3 bg-[#18a999] hover:bg-[#1e8e7e] rounded-md text-lg font-medium text-white w-full block text-center"
                    >
                        Download APK From GitHub
                    </Link>
                    <a href="https://apps.obtainium.imranr.dev/redirect?r=obtainium://add/https://github.com/coreply/coreply">
                        <img
                            src="https://raw.githubusercontent.com/ImranR98/Obtainium/refs/heads/main/assets/graphics/badge_obtainium.png"
                            alt="Get it on Obtainium"
                            height="60"
                            className="mt-4 mx-auto w-48 object-contain"
                        />
                    </a>
                    <p className="mb-4">
                        You may turn back on security features after setting up Coreply.
                        {/* Read more:&nbsp;
                        <a
                            href="https://www.howtogeek.com/google-play-killing-indie-android-apps/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 underline"
                        >
                            Google Play’s Rules Are Killing Indie Android Apps
                        </a> */}
                        {/* &nbsp;[How-To Geek] */}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PopupModal;
